import React from 'react'
import PropTypes from 'prop-types'
import PrimaryButton from 'components/PrimaryButton'

const EmptyState = ({ text, cta, ctaFilter, onFilter, onDiscoverEventsClick }) => (
  <div className="flex flex-col justify-center items-center px-4 py-20 bg-woodsmokeBlack rounded-md md:py-24">
    <div className="text-center text-gray-400 text-2xl mb-12">{text}</div>
    <PrimaryButton className="h-12 w-45 text-base" onClick={onDiscoverEventsClick}>
      Browse Events for you
    </PrimaryButton>
    <button
      className="text-white mt-4 bg-transparent text-sm font-semibold focus:outline-none hover:underline"
      onClick={() => onFilter(ctaFilter)}
    >
      {cta}
    </button>
  </div>
)

EmptyState.propTypes = {
  text: PropTypes.string,
  cta: PropTypes.string,
  ctaFilter: PropTypes.string,
  onDiscoverEventsClick: PropTypes.func,
  onFilter: PropTypes.func,
}

export default EmptyState
